<div class="subscription-expired-shell" role="dialog" aria-labelledby="subscription-expired-title">
  <span class="subscription-expired-orb subscription-expired-orb--left" aria-hidden="true"></span>
  <span class="subscription-expired-orb subscription-expired-orb--right" aria-hidden="true"></span>
  <span class="subscription-expired-grid" aria-hidden="true"></span>

  <div class="subscription-expired-content">
    <p class="subscription-expired-eyebrow">SUBSCRIPTION STATUS</p>

    <div class="subscription-expired-art" aria-hidden="true">
      @if (isTrial()) {
        <img src="svg/trial_expired_icon.svg" alt="" />
      }
      @if (!isTrial()) {
        <img src="svg/subscription_expired_icon.svg" alt="" />
      }
    </div>

    <h2 id="subscription-expired-title">
      @if (isTrial()) {
        Your trial has expired
      }
      @if (!isTrial()) {
        Your subscription has expired
      }
    </h2>

    <p class="subscription-expired-copy">
      Upgrade your plan to continue using the app and keep your screens active without interruption.
    </p>

    <div class="subscription-expired-badges" aria-label="Plan benefits">
      <span>Keep content live</span>
      <span>Manage more screens</span>
      <span>Instant upgrade</span>
    </div>

    <div class="subscription-expired-actions">
      <button mat-button class="subscription-expired-secondary" (click)="logout()">Logout</button>
      <button mat-flat-button class="subscription-expired-primary" (click)="upgrade()">Upgrade</button>
    </div>
  </div>
</div>
